import {defineStore} from 'pinia';

export const dashboardStore = defineStore('dashboardStore', {
	state: () => {
		return {
			dateRange: {
				from: null,
				to: null,
				preset: null,
				referenceYear: 1
			},
			hotelFilter: [],
			room: 1,				// 1 => single 2 => double,
			resolution: 'month'		// month / week / day
		}
	},
	getters: {},
	actions: {}
})
